import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// markdown样式
import "github-markdown-css";
// 代码高亮
import 'highlight.js/styles/atom-one-light.css'
import hljs from "highlight.js";
import kingCharts from "@ksyunfe/kingcharts";
import "./style/common.css"

Vue.use(kingCharts, {
  theme: {
    themeName: "测试主题", //自定义主题名称
    newTheme: false, //合并主题或者覆盖主题
    themeOption: {}, //主题配置
  },
});
Vue.config.productionTip = false;

Vue.directive("highlight", function (el) {
  const blocks = el.querySelectorAll("pre code");
  blocks.forEach((block) => {
    hljs.highlightBlock(block);
  });
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
